import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { tap } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { TranslationService } from '@services/translation.service';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InputComponent implements OnInit {
  @Input() disabled = false;
  @Input() showErrorAsTooltip: boolean;
  @Input() placeholder;
  @Input() label;
  @Input() control;
  @Input() tooltip;
  @Input() hideInput;
  @Input() customErrorMessages: { [key: string]: string } = {};
  @Input() hideErrorContent: boolean = false;
  @Input() showSearchIcon: boolean = false;
  @Input() showClearButton: boolean = false;
  @Output() enterKey = new EventEmitter<KeyboardEvent>();
  public showHiddenInput: boolean = false;
  // probably make the errorMessages modular
  public errorMessages = {
    mustHaveNumber: this.translationService.getTranslatedContent(
      'must_contain_a_number',
      'Must Contain A Number'
    ),
    mustHaveLowercase: this.translationService.getTranslatedContent(
      'musthavelowercase',
      'Must Have Lowercase Characters'
    ),

    mustHaveUpercase: this.translationService.getTranslatedContent(
      'must_have_uppercase',
      'Must have Uppercase'
    ),
    mustHaveSpecialCharacter: this.translationService.getTranslatedContent(
      'must_have_special_character',
      'Must have Special Character'
    ),
    minlength: this.translationService.getTranslatedContent(
      'does_not_meet_minimum_length',
      'Does Not Meet Minimum Length'
    ),
    mustMatchInput: this.translationService.getTranslatedContent(
      'does_not_match',
      'Does Not Match'
    ),
    numbersOnly: this.translationService.getTranslatedContent(
      'only_numbers',
      'Only numbers'
    ),
    urlInvalid: this.translationService.getTranslatedContent(
      'url_is_invalid',
      'URL is invalid'
    ),
    required: this.translationService.getTranslatedContent(
      'required',
      'Required'
    ),
    email: this.translationService.getTranslatedContent(
      'invalid_email',
      'Please enter a valid email address'
    ),
    noWhitespace: this.translationService.getTranslatedContent(
      'no_whitespace',
      'No whitespace'
    ),
    duplicate: this.translationService.getTranslatedContent(
      'must_be_unique',
      'Must be unique'
    ),

    duplicateName: this.translationService.getTranslatedContent(
      'must_be_a_unique_name',
      'Must be a unique name'
    ),
    invalidProviderName: this.translationService.getTranslatedContent(
      'invalid_provider_name',
      'Must have no whitespace or unscores and be more than 5 characters'
    ),
    alphanumericHyphenUnderscore: this.translationService.getTranslatedContent(
      'alphanumeric_hyphen_underscore_only',
      'Only alphanumeric characters, hyphens, and underscores'
    ),
  };
  public control$;
  public form$;
  public isRequired: boolean = false;
  constructor(
    private cdr: ChangeDetectorRef,
    private translationService: TranslationService
  ) {}

  ngOnInit() {
    if (this.control?.validator) {
      this.isRequired = this.control.validator(
        new UntypedFormControl()
      )?.required;
    }
    if (this?.control?.statusChanges) {
      this.control$ = this?.control?.statusChanges.pipe(
        tap(() => this.cdr?.detectChanges())
      );
    }
  }

  get isDisabled(): boolean {
    return this.disabled || !!this.control?.disabled;
  }

  get readonlyAttr(): boolean {
    return !!(this.disabled && !this.control?.disabled);
  }

  get error() {
    if (
      !this.control?.errors ||
      !Object.keys(this?.control?.errors || {}).length
    )
      return null;

    const isControlInteracted = this?.control?.dirty || this?.control?.touched;
    if (!isControlInteracted) return null;
    const firstErrorKey = Object.keys(this?.control?.errors).find(
      key => this?.control?.errors?.[key]
    );

    return firstErrorKey || null;
  }
  get errorMessage() {
    const errorKey = this.error;
    if (errorKey) {
      return (
        this.customErrorMessages?.[errorKey] ||
        this.errorMessages?.[errorKey] ||
        this?.error ||
        ''
      );
    }
    return null;
  }

  clearInput() {
    if (this.control) {
      this.control.setValue('');
      this.control.markAsPristine();
      this.control.markAsUntouched();
    }
  }
}
